import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_READY_TO_SHARE_PREDRAFTED = createFcmDetails(
	'starter_experience_ready_to_share_predrafted',
	{
		owner: 'Axolotls',
		import: false,
		context: 'Starter Dashboard',
		description: 'Shows pre drafted post module only to US users',
		template: {
			experimentName: undefined,
		},
	},
);
